import { Route, Navigate } from "react-router-dom";

import { CreateDataset } from "./CreateDataset";
import { CreateDatasetEvent } from "./CreateDatasetEvent";
import { Dataset } from "./Dataset";
import { loadDatasetByName } from "./loaders";

export const DatasetsRoutes = () => [
  <Route key={"/"} index element={<Navigate to="/search" replace />} />,
  <Route key={"create"} path="create" element={<CreateDataset />} />,
  <Route
    key={"name"}
    path="name/:datasetName"
    loader={loadDatasetByName}
    shouldRevalidate={({ currentUrl, nextUrl }) => {
      return currentUrl.pathname !== nextUrl.pathname;
    }}
    element={<Dataset />}
  />,
  <Route
    key={"id/events/create"}
    path=":datasetPath/events/create"
    element={<CreateDatasetEvent />}
  />,
  <Route key={"id/*"} path=":datasetPath/*" element={<Dataset />} />,
];
